import { IonText } from "@ionic/react";
import PageLayout from "../components/layout";

const Credit : React.FC = ()=>{
    return(
        <PageLayout title='Kredit dan Atribut'>
            <IonText>
                Aplikasi ini di kembangkan oleh Ismail (@xviidev)
            </IonText>
        </PageLayout>
    )
}

export default Credit;